import { render } from "./ListAgreements.vue?vue&type=template&id=fd6fc34c&scoped=true"
import script from "./ListAgreements.vue?vue&type=script&lang=js"
export * from "./ListAgreements.vue?vue&type=script&lang=js"

import "./ListAgreements.vue?vue&type=style&index=0&id=fd6fc34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6fc34c"]])

export default __exports__